import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_UPLOAD: GlameraIconDefinition = {
  name: 'upload',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-upload-group">
      <path class="glm-upload-shaft" d="M12 3v12"></path>
      <path class="glm-upload-head" d="m17 8-5-5-5 5"></path>
      <path class="glm-upload-tray" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-upload-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './upload.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class UploadIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_UPLOAD;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
